var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "manifestdetails"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), (_vm.showparent == true) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchantname),
      callback: function($$v) {
        _vm.merchantname = $$v
      },
      expression: "merchantname"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.rubiconManifestID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('rubiconmanifestid')
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('manifestReport.table.columns.rubiconManifestID'),
      "name": "rubiconmanifestid",
      "id": "rubiconmanifestid"
    },
    model: {
      value: (_vm.Rubiconmanifestid),
      callback: function($$v) {
        _vm.Rubiconmanifestid = $$v
      },
      expression: "Rubiconmanifestid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rubiconmanifestid')),
      expression: "errors.has('rubiconmanifestid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('rubiconmanifestid')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.WMSManifestID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('WMSmanifestid')
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('manifestReport.table.columns.WMSManifestID'),
      "name": "WMSmanifestid",
      "id": "WMSmanifestid"
    },
    model: {
      value: (_vm.WMSmanifestid),
      callback: function($$v) {
        _vm.WMSmanifestid = $$v
      },
      expression: "WMSmanifestid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('WMSmanifestid')),
      expression: "errors.has('WMSmanifestid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('WMSmanifestid')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.courierName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couriername),
      expression: "couriername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('not_in:Choose'),
      expression: "'not_in:Choose'"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.couriername = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.select')) + _vm._s(_vm.$t('manifestReport.table.columns.courierName')))]), _vm._v(" "), _vm._l((_vm.listshippingcompanyData), function(shippingcompany_obj) {
    return _c('option', {
      domProps: {
        "value": shippingcompany_obj.shippingcompany
      }
    }, [_vm._v(_vm._s(shippingcompany_obj.shippingcompany) + "\n                      ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.channelName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.select')) + _vm._s(_vm.$t('manifestReport.table.columns.channelName')))]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v("\n                        " + _vm._s(channel.saleschannel))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.manifestStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-plus-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manifeststatus),
      expression: "manifeststatus"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('manifeststatus')
    },
    attrs: {
      "name": "manifeststatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.manifeststatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.select')) + _vm._s(_vm.$t('manifestReport.table.columns.manifestStatus')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "open"
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "handover"
    }
  }, [_vm._v("Handover")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "closed"
    }
  }, [_vm._v("Closed")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Manifest Images Uploaded")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-plus-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manifestImagesUploaded),
      expression: "manifestImagesUploaded"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('manifeststatus')
    },
    attrs: {
      "name": "manifestImagesUploaded"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.manifestImagesUploaded = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Option")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Uploaded")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("Not Uploaded")])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getManifestSearch(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" \n                    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetflt
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                      " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 col-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('manifestReport.table.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-8 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 col-4 cardlistheader "
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e(), _vm._v(" "), (_vm.download && _vm.listManifestDetails.length > 0 && !_vm.show) ? _c('div', {
    staticClass: "col-md-2 col-8 "
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listManifestDetails.length > 0 && !_vm.download) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.getManifestData(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listManifestDetails.length > 0 && !_vm.download) ? _c('div', {
    staticClass: "col-md-1 col-3"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "data": _vm.listStockReportDataforxls,
      "header": _vm.dataFilter2,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [(_vm.isSpoc == false) ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("  " + _vm._s(_vm.$t('manifestReport.table.columns.rubiconManifestID')))])]) : _vm._e(), _vm._v(" "), (_vm.isSpoc == true) ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v("  " + _vm._s(_vm.$t('manifestReport.table.columns.sealId')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.WMSManifestID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$t('manifestReport.table.columns.noOfAWB')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.courierName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.aggregatorName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.channelName')))])]), _vm._v(" "), (_vm.isSpoc == false) ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.merchantName')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.vehicleNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.handoverPerson')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.manifestStatus')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('manifestReport.table.columns.action')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listManifestDetails), function(data, index) {
    return _c('tr', [(_vm.isSpoc == false) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.postdatadocumentno))]) : _vm._e(), _vm._v(" "), (_vm.isSpoc == true) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.document_no))]) : _vm._e(), _vm._v(" "), (data.imageupload_initiated > 0) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "cursor": "pointer",
        "color": "blue"
      },
      on: {
        "click": function($event) {
          _vm.getHandoverPDF(data.id)
        }
      }
    }, [_vm._v(_vm._s(data.id))]) : _vm._e(), _vm._v(" "), (data.imageupload_initiated == 0) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.id))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.count))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.courier_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingprovider))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.channel_name))]), _vm._v(" "), (_vm.isSpoc == false) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.merchantname))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehicle_no))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.handover_person))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.manifest_status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.created_at))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100%"
      }
    }, [_c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      attrs: {
        "data-toggle": "tooltip",
        "title": "View"
      },
      on: {
        "click": function($event) {
          _vm.showchild(data.id)
        }
      }
    }), _vm._v(" "), (data.imageupload_initiated == 0) ? _c('i', {
      staticClass: "fa fa-upload fa-lg mt-2 ml-3",
      attrs: {
        "title": "Upload Manifest Document"
      },
      on: {
        "click": function($event) {
          _vm.uploaddocument(data.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isSpoc == true) ? _c('i', {
      staticClass: "fa fa-print fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Print SPoc Sticker"
      },
      on: {
        "click": function($event) {
          _vm.openmodal(data.courier_name)
        }
      }
    }) : _vm._e()])])
  }), _vm._v(" "), ((_vm.listManifestDetails.result && _vm.listManifestDetails.result.length == 0) || _vm.listManifestDetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e()], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "no-close-on-backdrop": true,
      "no-fade": true,
      "id": "handovermodelid",
      "title": _vm.$t('orders.pickerTransfer')
    },
    model: {
      value: (_vm.pickerTransferShow),
      callback: function($$v) {
        _vm.pickerTransferShow = $$v
      },
      expression: "pickerTransferShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" Upload Manifest Document  ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeHandoverModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.ShowDeatils) ? _c('div', {
    staticClass: "form-group row mx-3",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin": "initial",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-6 my-3 "
  }, [_c('label', [_vm._v("Choose option to upload")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 my-3 mx-1"
  }, [(!_vm.selectfileFlag) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.chooseUpload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")]) : _vm._e(), _vm._v(" "), (_vm.selectfileFlag) ? _c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": _vm.$t('rtogrnb2b.uploadProduct')
    },
    on: {
      "click": function($event) {
        _vm.uploadManifestImage('camera')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectfileFlag) ? _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": _vm.$t('editedjson.selectProductLabel')
    },
    on: {
      "click": function($event) {
        _vm.uploadManifestImage('file')
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.HideDetails) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group row col-md-10"
  }, [(!_vm.cameraSection && _vm.fileSection) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveImage('file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v("\n            Upload")])])]) : _vm._e(), _vm._v(" "), (_vm.cameraSection && !_vm.fileSection) ? _c('div', {
    staticClass: "form-group row mx-3"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cameralist),
      expression: "cameralist"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cameralist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cameralist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cameraSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "hidden": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _vm._l((_vm.cameras), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.deviceId
      }
    }, [_vm._v(" " + _vm._s(client_obj.label))])
  })], 2)]), _vm._v(" "), _c('web-cam', {
    ref: "cameraImage",
    attrs: {
      "autoplay": "autoplay",
      "playsinline": _vm.playsinline,
      "height": 500,
      "width": 455,
      "screenshotFormat": _vm.screenshotFormat,
      "selectFirstDevice": _vm.selectFirstDevice
    },
    on: {
      "cameras": _vm.camerass
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.captureImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.capture')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.resetImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.retake')))])]), _vm._v(" "), (this.imageCaptured) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.saveImage('camera')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])]) : _vm._e()]) : _vm._e()])])]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.showmodal = false
      }
    },
    model: {
      value: (_vm.showmodal),
      callback: function($$v) {
        _vm.showmodal = $$v
      },
      expression: "showmodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Print Sticker")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closemodal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Print Quantity")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('quantity')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inwardList.printData.printBarcode.placeholder'),
      "name": "quantity",
      "id": "quantity"
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('quantity')),
      expression: "errors.has('quantity')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.printBarcode.errorMsg')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "290px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitprint
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.printData.printBarcode.printBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closemodal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("  " + _vm._s(_vm.$t('inwardList.printData.printBarcode.cancelBtn')))])])])], 1)])]), _vm._v(" "), (_vm.showparent == false) ? _c('div', [_c('div', [_c('printmanifestdetails', {
    attrs: {
      "id": Number(_vm.id),
      "clientid": _vm.client,
      "warehouseid": _vm.warehouseid,
      "clientid1": _vm.clientid
    }
  })], 1)]) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7604e9ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7604e9ca","hasScoped":true}!./src/views/components/manifestdetails/manifestdetails.component.html
// module id = 1739
// module chunks = 0